<div *ngIf="invoice as inv">

    <mat-card
      class="daxa-card invoice-details-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header class="d-flex align-items-center justify-content-between">
        <mat-card-title>
          <h5 class="mb-0">{{'Invoice Details' | translate}}</h5>
        </mat-card-title>

        
            <span class="title d-block text-body">
              Fakturanr.:
              <span class="text-black">#{{ inv.id }}</span>
            </span>

        <!-- Status -->
        <span class="status-chip"
            [ngClass]="{
                'sent': invoice.status === 'Sent',
                'failed': invoice.status === 'Failed'
            }"
        >
            {{ invoice.status || 'Pending' }}
        </span>
      </mat-card-header>

      <mat-card-content>

        <!-- Header info -->
        <div class="invoice-info d-md-flex align-items-center justify-content-between">
            
          <div>
            <span class="d-block text-body">{{'Invoice To' | translate}}</span>
            <span class="d-block">{{ inv.user.name }}</span>
            <span class="d-block">{{ inv.user.email }}</span>
            <span class="d-block">{{ inv.user.phone }}</span>
          </div>

          <div>
            <span class="title d-block text-body">
              Fakturadato:
              <span class="text-black">
                {{ inv.date | date:'dd MMM yyyy' }}
              </span>
            </span>

            <span class="d-block text-body">
              Forfaldsdato:
              <span class="text-black">
                {{ dueDate | date: 'dd MMM yyyy' }}
              </span>
            </span>
          </div>
        </div>

        <!-- =========================
             DETAILS TABLE
        ========================== -->
        <div class="recent-orders-table table-responsive">
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>{{'Description' | translate}}</th>
                <th>{{'Quantity' | translate}}</th>
                <th>{{'Unit' | translate}}</th>
                <th>{{'Unit Price' | translate}}</th>
                <th>{{'Price' | translate}} </th>
              </tr>
            </thead>
      
            <tbody>

              <ng-container *ngFor="let item of groupedItems; index as i">

                <!-- Parent row -->
                <tr class="expandable-row"
                    [class.has-children]="item.children.length > 0"
                    (click)="item.children.length > 0 && toggleRow(item.key)">
                  <td>{{ i + 1 | number:'2.0' }}</td>
                  <td class="text-black fw-medium">
                    <span *ngIf="item.children.length > 0" class="arrow" [class.open]="isExpanded(item.key)">▶</span>
                    {{ item.description }}
                  </td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.unit }}</td>
                  <td>{{ item.unitPrice }}</td>
                  <td>{{ item.price }}</td>
                </tr>

                <!-- Child rows -->
                <ng-container *ngIf="isExpanded(item.key)">
                  <tr *ngFor="let child of item.children" class="child-row">
                    <td></td>
                    <td>{{ child.description }}</td>
                    <td>{{ child.quantity }}</td>
                    <td>{{ child.unit }}</td>
                    <td>{{ child.unitPrice ?? '—' }}</td>
                    <td>{{ child.totalPrice }}</td>
                  </tr>
                </ng-container>

              </ng-container>

              <!-- Totals -->
              <tr>
                <td colspan="4"></td>
                <td class="text-body">Sub total</td>
                <td class="text-body">{{ invoice.subtotal }}</td>
              </tr>

              <tr>
                <td colspan="3" class="text-body">
                  (Momsfrit beløb: {{ invoice.vatFree }} - Momspligtigt beløb: {{ invoice.vatAmount }})
                </td>
                <td></td>
                <td class="text-body">Moms (25%)</td>
                <td class="text-body">{{ invoice.vat }}</td>
              </tr>

              <tr>
                <td colspan="4"></td>
                <td class="text-black fw-medium">Total DKK</td>
                <td class="text-black">{{ invoice.total }}</td>
              </tr>

            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
</div>